module.exports = __webpack_public_path__ + "static/media/ic-none.043a995a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic-none.svg
// module id = 655
// module chunks = 0